import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import moment from "moment";
import React from "react";
import ProgressiveImage from "react-progressive-image";
import partnerDefaultImg from "../../../assets/images/defaultImages/imageUpload-img.jpg";
import itemInfoStyles from "../../../assets/styles/components/itemInfoStyles";
import BreadCrumps from "../../../components/BreadCrups";
import SingleItemMenu from "../../../components/Menu/SingleItemMenu";
import NoContent from "../../../components/NoContent";

const styles = makeStyles((theme) => itemInfoStyles(theme));

export default (props) => {
  const { partnerDetails, crumps } = props;
  const classes = styles();

  return (
    <div>
      <BreadCrumps crumps={crumps} />
      {partnerDetails.name ? (
        <>
          <Grid container className={classes.topSection}>
            <Grid item xs={12} container justify="flex-start">
              <div>
                <ProgressiveImage
                  src={partnerDetails.pictureUrl}
                  placeholder={props.placeholder || partnerDefaultImg}
                >
                  {(src, loading) => (
                    <img
                      style={{
                        opacity: loading ? 0.7 : 1,
                        objectFit: "cover",
                        borderRadius: "6px",
                      }}
                      src={src}
                      alt="No cover"
                      className={classes.image}
                    />
                  )}
                </ProgressiveImage>
              </div>
            </Grid>
            <Grid
              item
              xs={12}
              container
              direction="column"
              spacing={2}
              className={classes.infoSection}
            >
              <Grid item className={classes.textInfo}>
                <Typography variant="h4" className={classes.texts}>
                  {partnerDetails.name}
                </Typography>

                <Grid item className={classes.actions}>
                  <Grid container spacing={2} justify="flex-end">
                    <SingleItemMenu
                      horiz
                      background
                      menu={props.actions}
                      item={partnerDetails}
                    />
                  </Grid>
                </Grid>

                <Tooltip title="Author" placement="right-end" arrow>
                  <Typography variant="h6" className={classes.name}>
                    Status: {partnerDetails.status}
                  </Typography>
                </Tooltip>
                <Typography variant="body1" className={classes.texts}>
                  Added on: {moment(partnerDetails.createdAt).format("LLL")}
                </Typography>
                <a
                  href={partnerDetails.weblink}
                  className={classes.texts}
                  target="_blank"
                >
                  <Typography variant="body1" className="out_link">
                    Visit partner's site
                  </Typography>
                </a>
              </Grid>
            </Grid>
          </Grid>
        </>
      ) : (
        <NoContent title="Unable to find Partner" />
      )}
    </div>
  );
};
